import React from 'react'
import { IChildrenProp, IDiv } from 'types/components/components.interface';

import './MagellanPopupBottomButtons.scss'

interface IMagellanPopupBottomButtonsProps extends IChildrenProp, IDiv {}

const MagellanPopupBottomButtons = ({
  children,
  className = '',
  ...props
}: IMagellanPopupBottomButtonsProps) => {
  return (
    <div {...props} className={`magellan-popup-bottom-buttons ${className}`}>
      {children}
    </div>
  );
};

export default MagellanPopupBottomButtons